/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import HeaderMessage from './header/HeaderMessage';

const HeaderMessageNode = ({ messageRef, inquiry }) => {
  return (
    <HeaderMessage
      ref={messageRef}
      message={
        inquiry.checkList.available
          ? inquiry.checkList.question
          : inquiry.freeInput.title
      }
    />
  );
};

export default HeaderMessageNode;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/HeaderMessageNode.js